import { render, staticRenderFns } from "./WorkshopCanceledList.vue?vue&type=template&id=ed0c7986&scoped=true&"
import script from "./WorkshopCanceledList.vue?vue&type=script&lang=js&"
export * from "./WorkshopCanceledList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopCanceledList.vue?vue&type=style&index=0&id=ed0c7986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0c7986",
  null
  
)

export default component.exports